import type { TooltipRenderProps } from 'react-joyride';
import { Box } from '@/components/Box/Box';
import { COLORS } from '@/styles/colors';
import { Typography } from '@/components/Typography/Typography';
import { ButtonGroup } from '@/components/Button/ButtonGroup/ButtonGroup';
import { OnboardingGuideButton, StepDot } from './styles';
import { Tooltip } from '@/components/Tooltip/Tooltip';
import CloseIcon from '@/images/CloseIconNew.svg?react';

export const OnboardingGuideStep = ({
  step,
  index,
  size,
  tooltipProps,
  primaryProps,
  backProps,
  closeProps,
  skipProps,
}: TooltipRenderProps) => {
  const { title: primaryTitle } = primaryProps;
  const { title: backTitle } = backProps;
  const { title: skipTitle } = skipProps;
  const isFirstStep = index === 0;

  return (
    <Box
      {...tooltipProps}
      display='flex'
      flexDirection='column'
      background={COLORS.black}
      padding='12px 16px 16px'
      borderRadius='8px'
      maxWidth='400px'
      width='100%'
      rowGap='6px'
      position='relative'
    >
      {/* Close button should behave the same as primary "next" button */}
      <Box
        position='absolute'
        top='12px'
        right='12px'
        cursor='pointer'
        {...closeProps}
        title=''
        onClick={primaryProps.onClick}
      >
        <CloseIcon />
      </Box>
      <Box display='flex' flexDirection='column' rowGap='8px'>
        <Typography color={COLORS.grey[200]} fontWeight='medium' textAlign='center' paddingRight='14px'>
          {step.title}
        </Typography>
        {step.content}
        <Box width='100%' display='flex' alignItems='center' justifyContent='center' columnGap='6px'>
          {Array.from({ length: size }).map((_, stepIndex) => {
            return <StepDot isActive={stepIndex === index} key={stepIndex} />;
          })}
        </Box>
      </Box>

      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <ButtonGroup gap='8px'>
          <OnboardingGuideButton variant='close' {...skipProps} title='' data-tooltip-id='guide-skip-tooltip'>
            {skipTitle}
          </OnboardingGuideButton>
          <Tooltip id='guide-skip-tooltip'>Finish guide tour</Tooltip>
          <div />
        </ButtonGroup>

        <ButtonGroup gap='8px'>
          {!isFirstStep ? (
            <OnboardingGuideButton variant='back' {...backProps} title=''>
              {backTitle}
            </OnboardingGuideButton>
          ) : (
            <div />
          )}

          <OnboardingGuideButton {...primaryProps} title=''>
            {primaryTitle}
          </OnboardingGuideButton>
        </ButtonGroup>
      </Box>
    </Box>
  );
};
